import api from './baseApi';

export const getUsers = (params) => api.get('/users/client', params);
export const getUserTypes = () => api.get('/userType');
export const getUserProfile = () => api.get(`/users/client/profile`);

export function getUserInformation(userId) {
  return api.get('/users/' + userId);
}
